/* This file is autogenerated, see readme.md for instructions */
import ArrowKeyboardPreviousSvgIcon from '@bloomreach/banana-theme/icons/arrow-keyboard-previous.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const ArrowKeyboardPreviousIcon = forwardRef(
  (props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
    return (
      <Icon {...props} ref={forwardedRef}>
        <ArrowKeyboardPreviousSvgIcon />
      </Icon>
    );
  },
);

ArrowKeyboardPreviousIcon.displayName = 'ArrowKeyboardPreviousIcon';

export default ArrowKeyboardPreviousIcon;
